module.exports = __webpack_public_path__ + "img/home-bg.ad31b594.jpg";